/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from 'react';
import { string, object, arrayOf, shape } from 'prop-types';
import { Helmet } from 'react-helmet';

function SEO({ title, data }) {
  const {
    seoDescription: description,
    lang = 'fr',
    meta = [],
    title: siteTitle,
    author,
    googleSiteVerification,
  } = data;
  // const metaDescription = description || site.siteMetadata.description;
  // const metaTitle = title || site.siteMetadata.title;
  const titleSuffix = siteTitle && title ? ` | ${siteTitle}` : '';
  const titleToUse = title || siteTitle;
  // const schemaOrgJSONLD = {
  //   '@context': 'https://schema.org',
  //   '@type': 'Person',
  //   address: {
  //     '@type': 'PostalAddress',
  //     addressLocality: 'Seattle',
  //     addressRegion: 'WA',
  //     postalCode: '98052',
  //     streetAddress: '20341 Whitworth Institute 405 N. Whitworth',
  //   },
  //   colleague: ['http://www.xyz.edu/students/alicejones.html', 'http://www.xyz.edu/students/bobsmith.html'],
  //   email: 'mailto:jane-doe@xyz.edu',
  //   image: 'janedoe.jpg',
  //   jobTitle: 'Professor',
  //   name: 'Jane Doe',
  //   telephone: '(425) 123-4567',
  //   url: 'http://www.janedoe.com',
  // };

  return (
    <Helmet
      htmlAttributes={{ lang }}
      title={titleToUse}
      titleTemplate={`%s${titleSuffix}`}
      meta={[
        {
          name: 'description',
          content: description,
        },
        {
          name: 'author',
          content: author,
        },
        {
          property: 'og:title',
          content: titleToUse,
        },
        {
          property: 'og:description',
          content: description,
        },
        {
          property: 'og:type',
          content: 'website',
        },
        {
          name: 'twitter:card',
          content: 'summary',
        },
        {
          name: 'twitter:creator',
          content: author,
        },
        {
          name: 'twitter:title',
          content: titleToUse,
        },
        {
          name: 'twitter:description',
          content: description,
        },
        {
          name: 'google-site-verification',
          content: googleSiteVerification,
        },
      ].concat(meta)}
    >
      {/* Schema.org tags       <script type="application/ld+json">{JSON.stringify(schemaOrgJSONLD)}</script> */}
    </Helmet>
  );
}

SEO.propTypes = {
  title: string,
  data: shape({
    description: string,
    lang: string,
    meta: arrayOf(object),
    title: string,
    author: string,
    googleSiteVerification: string,
  }),
};

SEO.defaultProps = {
  title: '',
  data: {
    lang: 'fr',
    meta: [],
    description: '',
    title: undefined,
    author: '',
    googleSiteVerification: '',
  },
};

export default SEO;
